import type { APTContext } from "src/app/services/aptContext/apt-context";

export async function waitForReviewEngagementFetched(
  aptContext: APTContext,
  interval: number = 8,
  timeout: number = 30 * 1000,
): Promise<boolean> {
  if (aptContext.reviewDetailsReady()) {
    return true;
  }

  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkCondition = () => {
      if (aptContext.reviewDetailsReady()) {
        // return true;
        resolve(true);
      } else if (Date.now() - startTime >= timeout) {
        reject(
          new Error("Timeout waiting for review engagement to be fetched"),
        );
      } else {
        setTimeout(checkCondition, interval);
      }
    };

    checkCondition();
  });
}
